import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("If that email exists, we sent a reset link");
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="brut-card p-8 max-w-md w-full brut-shadow-lg">
        <div className="label-mono">Recover access</div>
        <div className="font-chivo font-black text-3xl uppercase tracking-tighter">Forgot password</div>
        {sent ? (
          <div className="mt-4 text-sm">If the email is registered you&apos;ll receive a reset link within a minute.</div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="label-mono">Email</label>
              <input required type="email" data-testid="fp-email"
                value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full border border-black px-3 py-2 mt-1" />
            </div>
            {err && <div className="border border-red-600 bg-red-50 p-2 text-xs text-red-700">{err}</div>}
            <button disabled={loading} data-testid="fp-submit"
              className="w-full bg-black text-white py-3 uppercase text-xs tracking-widest font-bold border border-black hover:translate-x-[2px] hover:translate-y-[2px] hover:brut-shadow-sm transition-transform duration-100">
              {loading ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}
        <Link to="/login" className="mt-4 inline-block text-[11px] uppercase tracking-widest hover:underline">Back to sign in</Link>
      </div>
    </div>
  );
}
